import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { Button } from "../components/ui/button";
import { api, formatApiError } from "./Admin";
import { PasswordFields, checkPasswords } from "../components/admin/ChangePasswordDialog";

export default function AdminReset() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [values, setValues] = useState({ next: "", confirm: "" });
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const onChange = (k, v) => setValues((p) => ({ ...p, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    const problem = checkPasswords(values);
    if (problem) return setError(problem);
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, new_password: values.next });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <div className="max-w-sm mx-auto px-6 py-20">
        <div className="rounded-3xl border border-slate-200 bg-white p-8 space-y-5" data-testid="reset-password-card">
          <div className="h-11 w-11 rounded-2xl bg-sky-50 text-sky-600 flex items-center justify-center">
            <KeyRound className="h-5 w-5" />
          </div>
          <h1 className="text-2xl font-semibold">Set a new password</h1>
          {done ? (
            <>
              <p className="text-sm text-slate-700" data-testid="reset-password-done">
                Your password has been changed. Any other logged-in devices have been logged out.
              </p>
              <Button asChild className="w-full h-11 rounded-full bg-slate-900 hover:bg-slate-800 text-white">
                <Link to="/admin" data-testid="reset-go-login">Go to login</Link>
              </Button>
            </>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <PasswordFields values={values} onChange={onChange} />
              {error && <p className="text-sm text-red-600" data-testid="reset-password-error">{error}</p>}
              <Button type="submit" disabled={loading || !token} data-testid="reset-password-submit"
                className="w-full h-11 rounded-full bg-slate-900 hover:bg-slate-800 text-white">
                {loading ? "Saving…" : "Save new password"}
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
